// ── 후원 정보 데이터 ─────────────────────────────────────
// 계좌번호, 링크 변경 시 이 파일만 수정하면 됩니다.

export const DONATION_INFO = {
  kakaopay: {
    url: "https://qr.kakaopay.com/FLUnVid2C",
    label: "💛 카카오페이로 후원하기",
    note: "※ PC에서 오류 시 모바일로 이용해주세요",
  },
  account: {
    bank: "카카오뱅크",
    number: "79798718026",
    holder: "정지원",
    type: "안심계좌",
    label: "🏦 계좌이체 (PC/모바일)",
    copyHint: "계좌번호를 길게 눌러 복사하세요",
  },
  gift: {
    label: "🎁 커피/기프티콘 후원",
    description: "커피 한 잔 혹은 기프티콘으로도 후원하실 수 있어요!",
    adminOnlyNote: "업로드한 내용은 관리자만 확인할 수 있습니다.",
  },
};
